import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "components/context/UserProvider";
import { toQuery, toQueryString } from "components/hooks/useQueryStringState";
import ListShort from "components/ui/atoms/ListShort";
import SourcingListItemShort from "models/sourcings/SourcingListItemShort";
import { useAllSourcing } from "models/sourcings/apiSourcing";
import { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";

const defaultFilter = {
  status: ["MANUAL_NOT_STARTED", "MANUAL_IN_PROGRESS"],
};
const SourcingWidget = ({ userId }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [state, setState] = useState({
    filter: {
      ...defaultFilter,
      sourcing_owner: userId,
      offset: 0,
    },
  });
  const [fetchParams, setFetchParams] = useState(null);
  const {
    data: sourcingList,
    status,
    error,
    refetch,
  } = useAllSourcing(fetchParams);
  const { countSourcing } = useContext(UserContext);
  const sourcingModal = useModal("SourcingDrawer");

  useEffect(
    () =>
      setFetchParams({
        ...defaultFilter,
        ...state.filter,
        ordering: "-status",
        offset: state.offset,
      }),
    [state],
  );

  const handleClick = (sourcing) => {
    return navigate(
      `/company/${sourcing.company_detail.id}${toQueryString({
        dealsAndSourcings: `Sourcing-${sourcing.id}`,
      })}`,
    );
  };
  return (
    <>
      <ListShort
        title={
          <Stack spacing={1} alignItems="center" direction="row">
            <Typography variant="subtitle2">
              <Link
                style={{ textDecoration: "none", color: "inherit" }}
                to={{
                  pathname: "/sourcing",
                  query: toQuery(state),
                }}
              >
                Sourcings
              </Link>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                backgroundColor: theme.palette_custom.yellow,
                borderRadius: "50%",
                width: "1rem",
                height: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {countSourcing
                ? countSourcing.MANUAL_NOT_STARTED +
                  countSourcing.MANUAL_IN_PROGRESS
                : ""}
            </Typography>
          </Stack>
        }
        emptyMessage="No Sourcings"
        resource={sourcingList}
        resourceStatus={status}
        addResource={() =>
          sourcingModal
            .show({
              formType: "create",
              initialValues: { sourcing_owner: userId },
            })
            .then(refetch)
        }
        state={state}
        setState={setState}
        ListItemComponent={SourcingListItemShort}
        primaryClick={handleClick}
        error={error}
        pagination
      />
    </>
  );
};

export default SourcingWidget;
